import { Injectable } from '@angular/core';
import { PopupComponent } from '../widgets/popup/popup.component';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  components: Map<string, PopupComponent> = new Map<string, PopupComponent>();
  constructor() { }
  show(id: string) {
    console.log("showing " + id);
    this.components?.get(id)?.show();
  }
  hide(id: string) {
    this.components?.get(id)?.hide();
  }
  hideAll() {

    this.components.forEach((comp: PopupComponent) => comp.hide());
  }
  register(id: string, component: PopupComponent) {
    this.components.set(id, component);
  }
  unregister(id: string, component: PopupComponent) {
    this.hide(id);
    this.components.delete(id);
  }
}
